import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectText } from "../../../translation/translationSlice";
import "./ListItem.scss";
import Toggle from "../Toggle";

const ListItem = React.memo((props) => {
  const dispatch = useDispatch();
  const t = useSelector(selectText);
  const valueType = props.valueType;
  return (
    <div className="ListItem">
      <div
        className="ListItem_background"
        onClick={(e) => props.action && dispatch(props.action)}
      />
      <div className="ListItem_icon">
        <i className={props.icon} />
      </div>
      <div className="ListItem_label">{t(props.label)}</div>
      {valueType === "String" && (
        <div
          className="ListItem_string-value"
          onClick={(e) => props.quickAction && dispatch(props.quickAction)}
        >
          {t(props.value)}
        </div>
      )}
      {valueType === "Boolean" && (
        <Toggle value={props.value} action={props.quickAction} />
      )}
      {valueType === "Color" && (
        <div
          className={`ListItem_color-value ${props.value}`}
          onClick={(e) => props.quickAction && dispatch(props.quickAction)}
        />
      )}
      <div className="ListItem_line" />
    </div>
  );
});

export default ListItem;
